import React from 'react';
import Permissions from 'react-redux-permissions';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Confirm from 'components/elements/confirm-element';
import Message from 'rc-message';

export default class AreaList extends BaseListContainer {
  constructor(props) {
    const funcApi = {
      getList: props.getListFunc,
    };

    let columns = [
      {
        dataField: '_id',
        headerStyle: {
          width: 10,
          minWidth: 10,
        },
        formatter: (id) => {
          return (
            <Permissions allowed={[`biodiversity.delete`]}>
              <Icon
                style={{ cursor: 'pointer' }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
                onClick={() => {
                  this.handelDelete(id);
                }}
              />
            </Permissions>
          );
        },
      },
      {
        dataField: 'Area',
        text: 'Vùng phân bố',
      },
      {
        dataField: 'District.Name',
        text: 'Quận/Huyện',
      },
      {
        dataField: 'Wards',
        text: 'Phường/Xã',
      },
      {
        dataField: 'Lat',
        text: 'Vĩ độ (°)',
      },
      {
        dataField: 'Lng',
        text: 'Kinh độ (°)',
      },
      {
        dataField: 'Square',
        text: 'Diện tích',
      },
      {
        dataField: 'Quantity',
        text: 'Số lượng cá thể',
      },
    ];
    super(props, funcApi, columns);
  }

  handelDelete = (id) => {
    if (!this.ConfirmElm) return;
    const { onDelete } = this.props;

    this.ConfirmElm.showConfirm({
      content: 'Bạn có muốn xoá ',
      cb: async (value) => {
        if (value) {
          const res = await onDelete(id);
          if (res.success) {
            Message.success({ content: 'Thành Công' });
            this.fetData();
          }
          if (res.error) Message.error({ content: res.message });
        }
      },
    });
  };

  renderHeaderContainer() {
    return (
      <div>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/AreaManagement/AreaList/index.js